<template>
    <Users
        :users="users"
        :user-roles="userRoles"
        :customers="customers"
        :designers="designers"
        :user-added="userAdded"
        :available-username="availableUsername"
        @createUser="createNewUser"
        @getAvailableUsername="getAvailableUsername"
        @searchDesigners="executeSearchDesigners"
        @searchCustomers="executeSearchCustomers"
    />
</template>
<script>
import { mapActions } from "vuex";
import Users from "./_components/Users.vue";
import api from "src/services/api.js";
import { mutations } from "src/global-store.js";

export default {
    name: "UsersModule",
    components: {
        Users,
    },
    data() {
        return {
            userRoles: [
                "ClientBasic",
                "ClientAdmin",
                "CompanyBasic",
                "CompanyAdmin",
                "Developer",
            ],
            userAdded: false,
            customers: [],
            designers: [],
            users: [],
            availableUsername: null,
        };
    },
    async created() {
        mutations.setNavbarTitle("Portal Users");
        try {
            this.users = await api.get("/users");
        } catch (error) {
            console.error(error);
        }
    },
    methods: {
        ...mapActions("customer", ["searchCustomers"]),
        ...mapActions("designer", ["searchDesigners"]),
        async createNewUser(user) {
            try {
                const data = await api.post("/users", user);
                const newUser = { id: data.id, status: "Active", ...user };
                this.users = [newUser, ...this.users];

                this.userAdded = true;
            } catch (error) {
                console.error(error);
            }
        },
        async getAvailableUsername({ fname, lname }) {
            try {
                const response = await api.get(
                    "/usernames/available?fname=" + fname + "&lname=" + lname,
                );
                this.availableUsername = response.username;
            } catch (error) {
                console.error(error);
            }
        },
        async executeSearchCustomers({ search, loading }) {
            loading(true);
            this.customers = await this.searchCustomers(search);
            loading(false);
        },
        async executeSearchDesigners({ search, loading }) {
            loading(true);
            this.designers = await this.searchDesigners(search);
            loading(false);
        },
    },
};
</script>
